<div class="auth-container">
  <div class="row auth-main">
    <div class="col-sm-6 px-0 d-none d-sm-block">
      <div
        class="left-img"
        style="background-image: url(assets/images/pages/bg-04.png)"
      ></div>
    </div>
    <div class="col-sm-6 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <form>
            <span class="error-header p-b-45"> 404 </span>
            <span class="error-subheader p-b-5">
              Parece que estas perdido
            </span>
            <span class="error-subheader2 p-b-5">
              La pagina que estas buscando, no esta disponible
            </span>
            <div class="container-auth-form-btn mt-5">
              <a
                class="auth-form-btn"
                color="primary"
                mat-flat-button
                routerLink="/"
              >
                Ir al inicio
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
